"use client";

import Loader from "@/components/Loader";
import { getBuilderPage } from "@/requests/builder";
import { ReactNode, useEffect, useRef, useState } from "react";

const mobileWidth = 768;

export default function HomeView({
  page,
  pageMobile,
  children,
}: {
  page: BuilderPage | null;
  pageMobile: BuilderPage | null;
  children?: ReactNode;
}) {
  const [builderPage, setBuilderPage] = useState<BuilderPage | null>(page);
  const [builderPageMobile, setBuilderPageMobile] =
    useState<BuilderPage | null>(pageMobile);

  const [loading, setLoading] = useState(false);

  const builderPageFetch = useRef({
    pending: false,
    error: false,
    mobile: !!pageMobile,
    desktop: !!page,
  });

  const hasServerMobilePage = !!pageMobile;
  const hasServerDesktopPage = !!page;

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") {
      return hasServerMobilePage && !hasServerDesktopPage;
    }

    return window.innerWidth < mobileWidth;
  });

  useEffect(() => {
    const handleResize = () => {
      const mobileNow = window.innerWidth < mobileWidth;
      setIsMobile(mobileNow);

      if (mobileNow) {
        if (!builderPageFetch.current.mobile) {
          setLoading(true);
          builderPageFetch.current.pending = true;

          getBuilderPage("home-page-mobile")
            .then((nextPage) => {
              setBuilderPageMobile(nextPage);
              builderPageFetch.current.mobile = !!nextPage;
            })
            .catch(() => {
              builderPageFetch.current.error = true;
              builderPageFetch.current.mobile = false;
            })
            .finally(() => {
              builderPageFetch.current.pending = false;
              setLoading(false);
            });
        }
      } else if (!builderPageFetch.current.desktop) {
        setLoading(true);
        builderPageFetch.current.pending = true;

        getBuilderPage("home_page")
          .then((nextPage) => {
            setBuilderPage(nextPage);
            builderPageFetch.current.desktop = !!nextPage;
          })
          .catch(() => {
            builderPageFetch.current.error = true;
            builderPageFetch.current.desktop = false;
          })
          .finally(() => {
            builderPageFetch.current.pending = false;
            setLoading(false);
          });
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const pageItem = isMobile
    ? builderPageMobile ?? builderPage ?? pageMobile ?? page
    : builderPage ?? page ?? builderPageMobile ?? pageMobile;

  if (loading && !pageItem) {
    return (
      <div className="flex justify-center items-center py-20">
        <Loader size={60} />
      </div>
    );
  }

  if (!pageItem) return null;

  return <>{children}</>;
}
